import { render, staticRenderFns } from "./PlusWithBorder.vue?vue&type=template&id=06902bb0"
import script from "./PlusWithBorder.vue?vue&type=script&lang=js"
export * from "./PlusWithBorder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports